import React from 'react';
import { motion } from 'framer-motion';
import './Services.css';
import interior from '../assets/images/interior.jpg';
import engine from '../assets/images/engine.jpg';
import tire from '../assets/images/tire.jpg';

const Services = () => {
  const services = [
    {
      icon: 'fas fa-home',
      title: 'Domestic Installations',
      description: 'Complete electrical wiring, lighting systems, and power installations for residential properties.',
      image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      icon: 'fas fa-industry',
      title: 'Industrial Installations',
      description: 'Heavy-duty electrical systems, motor controls, and power distribution for industrial facilities.',
      image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      icon: 'fas fa-battery-full',
      title: 'Inverter Systems',
      description: 'Professional installation and maintenance of inverter systems for reliable backup power solutions.',
      image: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      icon: 'fas fa-video',
      title: 'CCTV Installation',
      description: 'Complete security camera systems installation and monitoring for homes and businesses.',
      image: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      icon: 'fas fa-tools',
      title: 'Maintenance Services',
      description: 'Regular electrical maintenance, troubleshooting, and repair services for all installations.',
      image: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      icon: 'fas fa-lightbulb',
      title: 'Lighting Solutions',
      description: 'Modern LED lighting systems, smart controls, and energy-efficient lighting installations.',
      image: 'https://images.unsplash.com/photo-1524484485831-a92ffc0de03f?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    }
  ];

  return (
    <section id="services" className="services section">
      <div className="container">
        <div className="section-header text-center mb-4">
          <h2>Electrical Services & Solutions</h2>
          <p>Professional electrical installations and maintenance services for domestic and industrial needs</p>
        </div>
        
        <div className="services-grid grid grid-3">
          {services.map((service, index) => (
            <motion.div 
              key={index} 
              className="service-card card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              whileHover={{ y: -10, scale: 1.02 }}
            >
              <div className="service-image">
                <img src={service.image} alt={service.title} />
                <div className="service-overlay">
                  <motion.div 
                    className="service-icon"
                    whileHover={{ scale: 1.2, rotate: 360 }}
                    transition={{ duration: 0.3 }}
                  >
                    <i className={service.icon}></i>
                  </motion.div>
                </div>
              </div>
              <div className="service-content">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;